import { render, staticRenderFns } from "./AllVideos.vue?vue&type=template&id=4f784702&scoped=true&"
import script from "./AllVideos.vue?vue&type=script&lang=js&"
export * from "./AllVideos.vue?vue&type=script&lang=js&"
import style0 from "./AllVideos.vue?vue&type=style&index=0&id=4f784702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f784702",
  null
  
)

export default component.exports